import { render, staticRenderFns } from "./VectorDragHandles.vue?vue&type=template&id=4cde2f5d&scoped=true&"
import script from "./VectorDragHandles.vue?vue&type=script&lang=ts&"
export * from "./VectorDragHandles.vue?vue&type=script&lang=ts&"
import style0 from "./VectorDragHandles.vue?vue&type=style&index=0&id=4cde2f5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cde2f5d",
  null
  
)

export default component.exports